export interface ILicenciaPlantilla {
    CostoUnitario: number;
    Frecuencia: number;
    IVA: number;
    Id: number;
    /** Es arreglo, ej: "" | "1" | "1,2,3" */
    ModulosExtra: CLicenciaModuloExtra[];
    /** Ej.: "Licenciamiento mensual Kidi full" */
    Nombre: string;
}

export enum CLicenciaModuloExtra {
    Finanzas = 1
}

export enum CLicenciaConfigOrganizacionTipoRegistro {
    Cargo = 1,
    IVA = 2,
}

export interface ILicenciaConfigOrganizacion {
    CostoUnitario: number;
    DiaAplicacion: number;
    DiasTolerancia: number;
    Frecuencia: number;
    IVA: number;
    IdConfig: number;
    IdOrganizacion: number;
    InicioUTC: string;
    ModulosExtra: CLicenciaModuloExtra[];
    Nombre: string;
    VigenciaUTC: string | null;
    DetalleAdeudos: ILicenciaConfigOrganizacionDetalleAdeudo[];
}

export interface ILicenciaConfigOrganizacionDetalleAdeudo {
    IdMov: number; // 364,
    IdEscuela: number;
    Saldo: number; // 78,
    SaldoFinal: number; // 90.48,
    /** formato crudo "2024-07-15", internamente se modifica a "2024-07-15T00:00:00Z" */
    FechaAplicacion: string;
    /** formato crudo "2024-07-15", internamente se modifica a "2024-07-15T00:00:00Z" */
    FechaTolerancia: string;
    /** formato crudo "2024-07-15", internamente se modifica a "2024-07-15T00:00:00Z" */
    FechaInicio: string;
    /** formato crudo "2024-07-15", internamente se modifica a "2024-07-15T00:00:00Z" */
    FechaFin: string;
    TipoRegistro: CLicenciaConfigOrganizacionTipoRegistro.Cargo; // 1,
    Valor: number; // 78,
    Detalles: ILicenciaCOnfigOrganizacionDetalleAdeudoDetalle[];
}

export interface ILicenciaCOnfigOrganizacionDetalleAdeudoDetalle {
    IdMov: number; // 387,
    IdMovPadre: number; // 364,
    Saldo: number; // 90.48,
    TipoRegistro: CLicenciaConfigOrganizacionTipoRegistro; // 2,
    Valor: number; // 12.48
}